/* eslint-disable react-hooks/exhaustive-deps */

import { PaymentCycle } from "../../models/enumerations/payment-cycle";
import { useEffect, useState } from "react";
import { query, collection, where, getDocs, getFirestore } from 'firebase/firestore';
import { Modal } from "../modal/modal";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import OrganizationService from "../../utilities/services/organization-service";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useHistory } from "react-router-dom";
import { PlanId } from "../../models/enumerations/plan-id";
import { Loader } from "../loader/loader";
import { useTranslation } from "react-i18next";
import { Tabs } from "../../models/enumerations/tabs";
import Plans from "./plans";
import { Product } from "../../models/interfaces/product";
import { Price } from "../../models/interfaces/price";
// import FmsClients from "../fms-clients/fms-clients";
import { PlanType } from "../../models/enumerations/plan-type";
import { OrganizationStatus } from "../../models/enumerations/organization-status";
import { createLogger } from "../../utilities/logger";
import DowngradeModal from "./downgrade-modal";
import UserService from "../../utilities/services/user-service";
import CheckoutFormUpdate from "./checkout-form-update";
import CheckoutFormCreate from "./checkout-form-create";
import { OrganizationSubscription } from "../../models/interfaces/organization-subscription";
import OrganizationSubscriptionService from "../../utilities/services/organization-subscription-service";

const log = createLogger("ChangePlan");

interface ChangePlanProps {
}

const COMPONENT_CLASS = "c-change-plan";

const ChangePlan: React.FC<ChangePlanProps> = (props) => {

    const params = new URLSearchParams(window.location.search);
    const planTypeParamStr = params.get("plan");
    const paymentCycleParamStr = params.get("cycle");

    let planTypeParam: PlanId | undefined = undefined;
    let paymentCycleParam: PaymentCycle | undefined = undefined;

    if (planTypeParamStr === "core") {
        planTypeParam = PlanId.Core;
    }
    else if (planTypeParamStr === "pro") {
        planTypeParam = PlanId.Pro;
    }

    if (paymentCycleParamStr === "month") {
        paymentCycleParam = PaymentCycle.Monthly;
    }
    else if (paymentCycleParamStr === "year") {
        paymentCycleParam = PaymentCycle.Yearly
    }

    const { t } = useTranslation();
    const { state, setState } = useAuthState();
    const db = getFirestore();

    const [selectedProduct, setSelectedProduct] = useState<Product>();
    const [selectedPrice, setSelectedPrice] = useState<Price>();
    const [upgradeModalOpen, setUpgradeModalOpen] = useState<boolean>(planTypeParam ? true : false);
    const [downgradeModalOpen, setDowngradeModalOpen] = useState<boolean>(false);
    const [paymentSuccessModalOpen, setPaymentSuccessModalOpen] = useState<boolean>(false);
    const [paymentFailedModalOpen, setPaymentFailedModalOpen] = useState<boolean>(false);
    const [isUpgrading] = useState(false);
    const [products, setProducts] = useState<any[]>();
    const [isLoading, setIsLoading] = useState(true);
    const [isPaymentSuccess] = useState(false);
    const [isPaymentFail] = useState(false);
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY as string);
    const history = useHistory();
    const [paymentFailed, setPaymentFailed] = useState<boolean>(false);
    const [paymentSuccessful, setPaymentSuccessful] = useState<boolean>(false);
    const [orgSub, setOrgSub] = useState<OrganizationSubscription>();

    useEffect(() => {
        const fetchOrgSub = async () => {
            if (state.organization.id) {
                let orgSubArr = await OrganizationSubscriptionService.getByOrganizationId(state.organization.id);

                if (orgSubArr && orgSubArr?.length !== 0 && orgSubArr[0]) {
                    setOrgSub(orgSubArr[0]);
                }
            }
        }

        if (!orgSub && state.organization.id) {
            fetchOrgSub();
        }

    }, [paymentFailed, paymentSuccessful, products])

    useEffect(() => {
        const getProductsAndPrices = async () => {
            setIsLoading(true);

            // Query to get all active products
            const q = query(
                collection(db, 'products'),
                where('active', '==', true)
            );
            const querySnapshot = await getDocs(q);
            // Use Promise.all to fetch all prices in parallel
            const productPromises = querySnapshot.docs.map(async (productDoc) => {
                const prices: any[] = [];
                const pricesCollection = collection(productDoc.ref, 'prices');
                const priceQuerySnapshot = await getDocs(pricesCollection);
                priceQuerySnapshot.docs.forEach((item) => {
                    prices.push({ data: item.data(), id: item.id });
                });

                // Combine product data and its prices
                return {
                    product: { data: productDoc.data(), id: productDoc.id },
                    prices: prices,
                };
            });
            // Wait for all productPromises to complete
            const resolvedProducts = await Promise.all(productPromises);
            setProducts(resolvedProducts);

            if (planTypeParam) {
                const product = resolvedProducts.find((item) => item.product.id === planTypeParam)

                if (product && product.product.id) {
                    setSelectedProduct(product.product.data)

                    const tempSelectedPrice = product.prices.find((item: any) => paymentCycleParam === PaymentCycle.Yearly ? item.data.interval !== "month" : item.data.interval === "month");

                    setSelectedPrice({ ...tempSelectedPrice.data, id: tempSelectedPrice.id });
                }
            }

            setIsLoading(false);
        };

        if (!products || products.length === 0) {
            getProductsAndPrices();
        }
    }, [])

    const updateOrgState = async () => {
        if (!state.organization.id) {
            return;
        }

        setIsLoading(true);

        try {
            const updatedOrg = await OrganizationService.get(state.organization.id);

            if (updatedOrg && updatedOrg.id) {
                log.info("Org state refreshed after plan change", {
                    organizationId: updatedOrg.id,
                    organizationName: updatedOrg.name,
                    planBefore: state.organization.plan?.value,
                    planAfter: updatedOrg.plan?.value,
                    status: OrganizationStatus[Number(updatedOrg.status)] ?? updatedOrg.status,
                    source: "change-plan-updateOrgState",
                });

                // If downgraded
                if ((state.organization.plan?.value === PlanType.Pro || state.organization.plan?.value === PlanType.Business)
                    && updatedOrg.plan?.value === PlanType.Core) {

                    // Check if the user count or license count exceed the limit
                    if ((updatedOrg.userCount !== undefined && updatedOrg.userLimit !== undefined &&
                        updatedOrg.userCount > updatedOrg.userLimit) ||
                        (updatedOrg.mySymmioLicenseCount !== undefined && updatedOrg.mySymmioLicense !== undefined &&
                            updatedOrg.mySymmioLicenseCount > updatedOrg.mySymmioLicense)) {
                        await UserService.deactivateAllUsers(updatedOrg, state.user || null);
                        log.info("All users deactivated on plan downgrade", {
                            organizationId: updatedOrg.id,
                            userCount: updatedOrg.userCount,
                            userLimit: updatedOrg.userLimit,
                            licenseCount: updatedOrg.mySymmioLicenseCount,
                            licenseLimit: updatedOrg.mySymmioLicense,
                        });
                    }
                }

                setState((state) => ({
                    ...state, ...{ organization: updatedOrg }
                }));

                let orgSubArr = await OrganizationSubscriptionService.getByOrganizationId(updatedOrg.id);

                if (orgSubArr && orgSubArr?.length !== 0 && orgSubArr[0]) {
                    setOrgSub(orgSubArr[0]);
                }
            }
        } catch (e) {
            log.error("Failed to update organization state after plan change", {
                exception: e,
                organizationId: state.organization?.id,
            });
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        const openModal = async () => {
            if (paymentSuccessful) {
                await updateOrgState();
                setUpgradeModalOpen(false);
                setPaymentSuccessModalOpen(true);
                setPaymentSuccessful(false);
            }
            else if (paymentFailed) {
                setPaymentFailedModalOpen(true);
                setPaymentFailed(false);
            }
        }
        openModal();

    }, [paymentFailed, paymentSuccessful, products])

    const handleSelectedProduct = (data: any) => {
        if (products && products.length !== 0) {
            const product = products?.find((item) => item.product.id === data.id)
            setSelectedProduct(product.product.data)

            const tempSelectedPrice = product.prices.find((item: any) => data.interval === PaymentCycle.Monthly ? item.data.interval === "month" : item.data.interval !== "month");

            setSelectedPrice({ ...tempSelectedPrice.data, id: tempSelectedPrice.id });

            if ((state.organization.plan?.value === PlanType.Pro || state.organization.plan?.value === PlanType.Business) && data.id === PlanId.Core) {
                setDowngradeModalOpen(true);
            }
            else {
                setUpgradeModalOpen(true);
            }
        }
    }

    return (
        <>
            <Loader
                isVisible={isLoading} />
            <Modal
                isOpen={paymentSuccessModalOpen}
                isLoading={isPaymentSuccess}
                onClose={() => {
                    setPaymentSuccessModalOpen(false);
                    history.push(`/settings?active=${Tabs.Billing}`);
                }}
                defaultCenterModal={true}
                submitButtonText={t('buttons.btn_continue')}
                onSubmit={() => {
                    setPaymentSuccessModalOpen(false);
                    history.push(`/settings?active=${Tabs.Billing}`);
                }}
                title={t('billing.planUpgraded')}>
                <div className={`${COMPONENT_CLASS}__modal-wrapper`}>
                    <div className={`${COMPONENT_CLASS}__modal-content`}>
                        <p><b>{t('billing.thankYou')}</b></p>
                        <p>{t('billing.emailConfirmation')}</p>
                    </div>
                </div>
            </Modal>

            <Modal
                isOpen={upgradeModalOpen}
                isLoading={isUpgrading}
                onClose={() => {
                    setUpgradeModalOpen(false);
                }}
                title={t('billing.upgradePlan')}>
                {stripePromise && products && products.length > 0 &&
                    selectedProduct && selectedPrice && orgSub &&
                    <>
                        <Elements stripe={stripePromise} options={{ mode: 'setup', currency: 'usd' }}>
                            {state.organization.plan?.value === PlanType.Trial
                                ?
                                <CheckoutFormCreate
                                    setUpgradeModalOpen={setUpgradeModalOpen}
                                    paymentSuccessful={setPaymentSuccessful}
                                    paymentFailed={setPaymentFailed}
                                    onChangePlan={() => { setUpgradeModalOpen(false); }}
                                    returnUrl={`/settings/upgrade`}
                                    paymentCycle={
                                        selectedPrice
                                            ? selectedPrice.interval === "month"
                                                ? PaymentCycle.Monthly : PaymentCycle.Yearly
                                            : undefined
                                    }
                                    selectedProduct={selectedProduct}
                                    selectedPrice={selectedPrice}
                                    products={products}
                                    isCreating={false}
                                    isLoading={isLoading}
                                    setIsLoading={setIsLoading}
                                />
                                :
                                <CheckoutFormUpdate
                                    setUpgradeModalOpen={setUpgradeModalOpen}
                                    paymentSuccessful={setPaymentSuccessful}
                                    paymentFailed={setPaymentFailed}
                                    onChangePlan={() => setUpgradeModalOpen(false)}
                                    returnUrl={`/settings/upgrade`}
                                    paymentCycle={selectedPrice.interval === "month"
                                        ? PaymentCycle.Monthly
                                        : PaymentCycle.Yearly
                                    }
                                    selectedProduct={selectedProduct}
                                    selectedPrice={selectedPrice}
                                    isLoading={isLoading}
                                    setIsLoading={setIsLoading}
                                    orgSub={orgSub}
                                />
                            }
                        </Elements>
                        <Modal
                            isOpen={paymentFailedModalOpen}
                            isLoading={isPaymentFail}
                            onClose={() => {
                                setPaymentFailedModalOpen(false);
                            }}
                            title={t('pricing.checkoutPage.paymentDeclined.title')}
                            defaultCenterModal={true}
                            submitButtonText={t('buttons.btn_continue')}
                            onSubmit={() => {
                                setPaymentFailedModalOpen(false);
                            }}>
                            <div className={`${COMPONENT_CLASS}__modal-wrapper`}>
                                <div className={`${COMPONENT_CLASS}__modal-content`}>
                                    <p><b>{t('pricing.checkoutPage.paymentDeclined.line1')}</b></p>
                                    <p>{t('pricing.checkoutPage.paymentDeclined.line2')}</p>
                                    <p>{t('pricing.checkoutPage.paymentDeclined.line3')}</p>
                                </div>
                            </div>
                        </Modal>
                    </>
                }

            </Modal>

            {downgradeModalOpen &&
                <DowngradeModal
                    isOpen={downgradeModalOpen}
                    onClose={setDowngradeModalOpen}
                    onSubmit={() => setUpgradeModalOpen(true)}
                    isLoading={isLoading}
                />
            }

            <div className="p-0 md:px-16 px-8 pt-10 mx-auto" style={{ width: "980px" }}>
                <div className="text-center">
                    <h1 className="text-center mb-10">{t('pricing.upgradePage.title')}</h1>
                    <p className="text-sm whitespace-pre-line leading-9 font-light" dangerouslySetInnerHTML={{ __html: t('pricing.upgradePage.description') }}></p>
                </div>
                {/* <div className="w-full py-4 flex flex-col items-center text-center">
                    <FmsClients />
                </div> */}
                {products && products.length !== 0 && orgSub &&
                    <Plans
                        onProductSelect={handleSelectedProduct}
                        isUpgrade={true}
                        orgSub={orgSub}
                    />
                }
            </div >
        </>
    );
}

export default ChangePlan;